import { __assign } from "tslib";
import React from 'react';
import { Column } from '../../components/column';
import { Text } from '../../components/text';
import { LinkWrapper } from '../../components/link-wrapper';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { addBorderClasses } from './common';
import { websiteContainer, contactContainer } from './styles';
import MobileDivider from './mobile-divider';
export var SiteTitleSection = function (props) {
    var iconSrc = props.iconSrc, isRtl = props.isRtl, isVisible = props.isVisible, showBorderLeft = props.showBorderLeft, showBorderRight = props.showBorderRight, text = props.text, textColor = props.textColor, url = props.url, width = props.width, hasTopDivider = props.hasTopDivider, section = props.section, paddingLeft = props.paddingLeft, paddingRight = props.paddingRight, onSiteTitleClick = props.onSiteTitleClick;
    if (!isVisible) {
        return null;
    }
    var columnCssClass = "html-emails-footer-section ".concat(addBorderClasses({
        showBorderRight: showBorderRight,
        showBorderLeft: showBorderLeft,
        isRtl: isRtl,
    }), " bigger-column-height ").concat(mobileFullWidthColumnClassName);
    var businessAddressStyle = { maxHeight: '100px' };
    var linkItems = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "so-global-footer-text", style: __assign(__assign(__assign(__assign({}, contactContainer), (isRtl ? { display: 'inline' } : {})), { color: textColor }), businessAddressStyle) },
            React.createElement(LinkWrapper, { fontWeight: "inherit" },
                React.createElement(BdiWrapper, { text: text }))),
        React.createElement(React.Fragment, null, " "),
        React.createElement(React.Fragment, null, "\u00A0"),
        React.createElement("img", { className: "html-emails-footer-arrow-icon", height: 22, src: iconSrc, style: { verticalAlign: 'middle', border: '0' }, width: 22, alt: "" })));
    return (React.createElement(Column, { cssClass: columnCssClass, direction: isRtl ? 'rtl' : 'ltr', paddingRight: paddingRight, paddingLeft: paddingLeft, verticalAlign: "middle", width: width },
        hasTopDivider && (React.createElement(MobileDivider, { section: section, show: showBorderLeft })),
        React.createElement(Text, { align: "center", cssClass: "html-emails-footer-site-with-mobile-divider", padding: "0px 10px 0px 10px" },
            React.createElement("div", { style: websiteContainer },
                React.createElement("a", { className: "html-emails-footer-link", href: url, target: "_blank", onClick: onSiteTitleClick }, linkItems)))));
};
//# sourceMappingURL=footer-site-title.js.map